module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-modern_v2-en-4fca559c3869f5972ec9e6a5e59b203f.pdf";